import { CmsRegistrationRoot } from '../cms/cms-registration-root.interface';
import { CmsProtectionUpsellPanel } from '../protection-upsell/cms-protection-upsell-panel.interface';
import { CmsPersonalDetailsForm } from './cms-personal-details-form.interface';

export interface CmsPersonalDetailsPage
  extends CmsRegistrationRoot,
    CmsPersonalDetailsForm,
    CmsProtectionUpsellPanel {
  pageTitle: string;
  pageTitleCLP: string;
}
